/* Cart-drawer "Complete the Flora & Fauna collection": the Add all button (James, 2026-09-18).
   Since 2026-10-22 the strip itself renders with the drawer (bokja-cart-drawer.liquid), which also
   writes the missing variants into the button's data-variants; this file only handles the click.
   Adds go through window.BokjaCartAddMany (bokja-wishlist-add.js), one request and one drawer morph,
   after which the re-rendered drawer no longer offers what is now in the basket. */
(function () {
  if (window.__bokjaCartCompleteBound) return;
  window.__bokjaCartCompleteBound = true;

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('[data-bokja-cart-complete-all]');
    if (!btn || !window.BokjaCartAdd) return;
    e.preventDefault();
    var ids = (btn.dataset.variants || '').split(',').filter(Boolean);
    if (!ids.length || btn.disabled) return;
    btn.disabled = true;
    try {
      if (window.BokjaCartAddMany) { await window.BokjaCartAddMany(ids, btn); }
      else { for (var i = 0; i < ids.length; i++) { try { await window.BokjaCartAdd(ids[i], btn); } catch (err) { /* one failure never stops the rest */ } } }
    } finally {
      btn.disabled = false;
    }
  });
})();
